import { UserApi, type DbResult, type UserRow, type UserUpdateFields } from '../api/UserApi';

/**
 * Application-layer entry point for user queries. Pages and hooks call this instead of
 * touching Supabase or the API layer directly.
 */
export class UserService {
  static listUsers(status: 'all' | 'active' | 'deactivated' = 'all'): Promise<DbResult<UserRow[]>> {
    return UserApi.listUsers(status);
  }

  static updateUser(id: string, fields: UserUpdateFields): Promise<DbResult<null>> {
    return UserApi.updateUser(id, fields);
  }

  static deleteUser(id: string): Promise<DbResult<{ id: string }[]>> {
    return UserApi.deleteUser(id);
  }

  static findByEmail(email: string): Promise<DbResult<{ id: string }[]>> {
    return UserApi.findByEmail(email);
  }

  static getRole(id: string): Promise<DbResult<{ role: string }>> {
    return UserApi.getRole(id);
  }

  static listWorkerNames(): Promise<DbResult<{ id: string; name: string }[]>> {
    return UserApi.listWorkerNames();
  }

  static listActiveWorkers(): Promise<DbResult<{ id: string; name: string; email?: string }[]>> {
    return UserApi.listActiveWorkers();
  }

  static listWorkersAndDrivers() {
    return UserApi.listWorkersAndDrivers();
  }

  static getProfile(id: string) {
    return UserApi.getProfile(id);
  }

  static findById(id: string) {
    return UserApi.findById(id);
  }

  static findByName(name: string) {
    return UserApi.findByName(name);
  }

  static updateProfile(id: string, fields: { name: string; email: string; role: string }) {
    return UserApi.updateProfile(id, fields);
  }

  static insertProfile(row: { id: string; name: string; email: string; role: string }) {
    return UserApi.insertProfile(row);
  }
}
